import styled from 'styled-components'

export const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 44px;
  
  > div {
    padding: 4px;
  }
`

export const PlaceholderRow = styled.div<{ $height: number; $offset: number }>`
  height: ${({ $height }) => $height}px;
  margin-bottom: ${({ $offset }) => $offset}px;
`
